import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href = '#oferta'
}: CTAButtonProps) {
  const baseClasses = 'inline-block w-full sm:w-auto text-center py-5 px-8 md:px-12 text-xl md:text-2xl font-bold rounded-full bg-brand-gold text-brand-brown hover:bg-brand-goldDark transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1 duration-300';
  const handleClick = () => {
    trackAddToCart();
    onClick?.();
  };
  if (href) {
    return <a href={href} className={`${baseClasses} ${className}`} onClick={() => trackAddToCart()} data-id="element-173">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${className}`} data-id="element-174">
      {children}
    </button>;
}